import React from 'react';
import { CardImg, Card, CardTitle, CardText, CardBody, Col, Row, Button } from "reactstrap";

import styles from './styles.css';
// import APIhelper from '../APIhelper';
// import Heart from '../icons/heart';
import Arrow from '../icons/arrow';
import Alert from "../icons/alert";

import classnames from 'classnames';

export class ProductDetail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            buttonsTxt: 'ADD TO BAG',
            needToSelectAShade: false,
        }

        this.addToBag = this.addToBag.bind(this);
        this.onProductPage = this.onProductPage.bind(this);
    };

    componentDidUpdate(prevProp, prevState){
        const nextState = {};
        if(this.props.addedToBag != prevProp.addedToBag){
            this.setState({buttonsTxt: 'ADDED!'});
            setTimeout((function() { this.setState({buttonsTxt: 'ADD TO BAG'}); }).bind(this), 2000);
        }
        if((this.props.activeShade.hex && 
            this.props.activeShade.sku && 
            this.state.needToSelectAShade) || 
            (prevProp.activeShade.sku != this.props.activeShade.sku)){
                this.setState({needToSelectAShade: false});
        }
    }

    async addToBag(activeShade){
        if(activeShade.hex){
            gtag('event', 'add_to_cart', {
                'event_label': `sku:${activeShade.sku},hex:${activeShade.hex},coverage:${activeShade.coverage},finish:${activeShade.finish},regions:${activeShade.regions.join('|')}`,
                'event_category': 'ecommerce'
              });

              window.utag && utag.link({
                tealium_event: "add_to_cart",                
                component_type: "productactions",
                glamlab_product_category: this.props.activeCategory, // e.g. foundation
                glamlab_virtual_tryon_mode: localStorage.getItem("mode"), // e.g. photo
                
                // product attributes
                //
                product_id: [activeShade.productId],
                product_sku: [activeShade.sku],
                product_name: [activeShade.productName],
                product_brand: [activeShade.productBrand],
                product_variant_color: [activeShade.color],
              })
            this.props.addToBag(activeShade);

            await fetch(`https://${window.location.hostname}/services/v2/user/lite`);
            const token = JSON.parse(localStorage.getItem("sessionData"));
        
            const itemsToAdd = activeShade;
            fetch(`https://${window.location.hostname}/services/v5/cart/items/add`, {
              method: "POST",
              body: JSON.stringify({
                skuId: itemsToAdd.sku,
                quantity: 1,
              }), 
              headers: new Headers({
                "Api-Access-Control": `dyn_session_conf=${token.secureToken}`,
                "Content-Type": "application/json",
                "X-ULTA-CLIENT-CHANNEL": "app",
              }),
            })
            .then(async (response) => {
              if (response.ok) {
                window.open(`https://${window.location.hostname}/bag`, "_self")
                return response.json();
              }
              // TODO: retries
            })
            .catch((error) => console.error({ error }))
        } else {
            this.setState({needToSelectAShade: true}, () => {
                console.log(this.state.needToSelectAShade);
            });

            window.utag && utag.link({
                tealium_event: "add_to_cart",                
                component_type: "productactions",
                message: "Please select a shade to continue"
            })
        }
    }

    onProductPage() {
        window.utag && utag.link({
            action_label: "view more details",                
            action_type: "link",
        })
    }

    render() {

        // let sku = this.props.activeSKU;
        // let lang = this.props.activeShade.Languages;
        const activeShade = this.props.activeShade;

        return (
            <Card className={classnames('flex-row', styles.card)}>
                <div className={styles.imgWrap}>
                    <CardImg src={activeShade.paletteImage} />
                </div>
                
                <CardBody className={styles.body}>
                    <CardTitle className={styles.title}>
                        {activeShade.productBrand}
                    </CardTitle>
                    <CardText className={styles.productDetailName}>
                        {activeShade.productName}
                    </CardText>
                    {
                        this.state.needToSelectAShade &&
                        <CardText className={styles.color}>
                            <div className={styles.alert}>
                                <Alert />
                                <span>Please select a shade to continue.</span>
                            </div>
                        </CardText>
                    }
                    {
                        (activeShade.paletteName && !this.state.needToSelectAShade) &&
                        <CardText className={styles.color}>
                            <strong>Color:</strong> {activeShade.paletteName}
                        </CardText>
                    }
                    <div className={styles.row}>
                        <div style={{ display: 'none' }} className={styles.addToBagButton} 
                            onClick={() => { 
                                this.addToBag(activeShade);
                            }}>
                            <span>{this.state.buttonsTxt}</span>
                        </div>
                        <div style={{ margin: 'unset' }} className={styles.pdp}>
                            <a href={activeShade.paletteUrl} onClick={this.onProductPage} target="_blank">
                                <span>View more details</span>
                                <Arrow />
                            </a>
                        </div>
                        {/* <Heart className={styles.heart} /> */}
                    </div>
                </CardBody>
            </Card>
        )
    };
};